import { shouldEnableMockAdapters } from '@procurify/utils/src/testing/environment'
import mock from 'axios-mock-adapter'

import { genericApi } from '../config/api'
genericApi.interceptors.response.use(
  (request) => request,
  (error) => {
    throw error
  }
)

const genericApiMockAdapter = (() => {
  if (shouldEnableMockAdapters()) {
    return new mock(genericApi)
  } else {
    console.warn('genericApiMockAdapter is disabled in production')
    return null
  }
})()

export { genericApiMockAdapter }
